<!-- 煤棚库区堆位：数据来自 base_store（料场）+ base_store_area + base_store_sub -->
<template>
  <div class="location-manage-wrap">
    <coal-shed-layout />
  </div>
</template>

<script>
import CoalShedLayout from "./CoalShedLayout.vue";

export default {
  components: { CoalShedLayout },
};
</script>
<style scoped lang="scss">
.location-manage-wrap {
  position: relative;
  margin: 0;
  padding: 0;
  min-height: calc(100vh - 140px);
  display: flex;
  flex-direction: column;
}
</style>
